module.exports = __webpack_public_path__ + "img/icon_info-big.5070f57b.svg";